import React from "react";
import { HighScoreBoard } from "components/HighScoreBoard";
import { BoardEntry, getBoard, lastName } from "services/highScores";

interface HighScoreModalProps {
  onClose: () => void;
}

export const HighScoreModal = ({
  onClose,
}: HighScoreModalProps): JSX.Element => {
  const [allTime, setAllTime] = React.useState<BoardEntry[]>([]);
  const [weekly, setWeekly] = React.useState<BoardEntry[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<string>("");

  React.useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const [at, wk] = await Promise.all([
          getBoard("all_time", 50),
          getBoard("weekly", 50),
        ]);
        if (!cancelled) {
          setAllTime(at);
          setWeekly(wk);
        }
      } catch {
        if (!cancelled) setError("Could not load high scores. Try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  // Close on Escape.
  React.useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const mine = lastName();

  return (
    <div className="hs-modal-overlay" onClick={onClose}>
      <div
        className="hs-modal"
        role="dialog"
        aria-modal="true"
        aria-label="High scores"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="hs-modal-close"
          onClick={onClose}
          aria-label="Close high scores"
        >
          ×
        </button>
        <h3 className="hs-modal-title">High Scores</h3>
        {loading ? (
          <div className="hs-board-empty">Loading…</div>
        ) : error ? (
          <div className="hs-error">{error}</div>
        ) : (
          <>
            <HighScoreBoard
              title="All-time"
              entries={allTime}
              highlightName={mine}
              displayLimit={20}
            />
            <HighScoreBoard
              title="This week"
              entries={weekly}
              highlightName={mine}
              displayLimit={20}
            />
            <div className="hs-legend">* Maximum three spots per player.</div>
          </>
        )}
      </div>
    </div>
  );
};
